import React from 'react'
import { ContactForm } from '../templates/Contact/contactForm'
import ContactMainBanner from '../templates/Contact/contactMainBanner'

export const ContactPage = () => {
  return (
    <div>
        <ContactMainBanner />
        <ContactForm />
    </div>
  )
}
